import { DateTime } from 'luxon';

export function formatWeekInterval(weekStartISO: string, weekEndISO: string) {
  const start = DateTime.fromISO(weekStartISO);
  const end = DateTime.fromISO(weekEndISO);

  const locale = 'ru';

  if (start.hasSame(end, 'month') && start.hasSame(end, 'year')) {
    return `${start.day} – ${end.day} ${start.setLocale(locale).toFormat('MMMM yyyy')}`;
  } else if (start.hasSame(end, 'year')) {
    return `${start.day} ${start.setLocale(locale).toFormat('MMMM')} – ${end.day} ${end.setLocale(locale).toFormat('MMMM yyyy')}`;
  } else {
    return `${start.day} ${start.setLocale(locale).toFormat('MMMM yyyy')} – ${end.day} ${end.setLocale(locale).toFormat('MMMM yyyy')}`;
  }
}
